import axios from 'axios';
import { action, Module, mutation, VuexModule } from 'vuex-class-component';
import { vxm } from '@/store.vuex';

@Module({ namespacedPath: 'protectedinformation/' })
export class ProtectedInformationStore extends VuexModule {
    
    @action({ mode: 'mutate' })
    public async getProtectedInformation(){
     const response =  await axios.get('/wl-profile-svc/api/v2/protectedinfo',{
            headers: {
                Authorization: `Bearer ${vxm.users.getToken}`,
              },
        });
     console.log("protected info get response ",response);
     return response.data.data;
    }

    @action({ mode: 'mutate'})
    public async updateProtectedInformation(protectedInfo){
        protectedInfo.dob = vxm.utility.convertLocalTimeInEpochToUTC(protectedInfo.dob);
        protectedInfo.doNotTriggerEvent = false;
        const jwtToken = vxm.users.getToken;
        const token = 'Bearer ' + jwtToken;
        const payLoadUrl = '/wl-profile-svc/api/v2/protectedinfo';
        const response = await axios.post(payLoadUrl,protectedInfo,{
            headers: {
                'Content-Type': 'application/json',
                 Authorization: token,
              },
        });
        console.log("update notification preference",response);
        if (response.data.meta.success) {
            vxm.users.getProfileStrength();
          }
        return response;
    }

}